let openModalCount = 0;

export function addModalOpenClass() {
  openModalCount += 1;
  document.body?.classList?.add('modal-open');
}

export function removeModalOpenClass() {
  openModalCount = Math.max(openModalCount - 1, 0);

  if (openModalCount === 0) {
    document.body?.classList?.remove('modal-open');
  }
}